<template>
  <div class="wrapper">
    <div class="shop-container">
      <div class="nav">
        <router-link to="home">{{$t('home')}}</router-link>
        <span>></span>
        <span>{{navName}}</span>
      </div>
      <div class="main">
        <div class="l bgw">

          <template v-for="(item,index) in options" >
            <div class="list-wrap" v-if="item.show" :key="index">
              <h3 class="title">{{item.title}}</h3>
              <ul>
                <li v-for="(nav,i) in item.list" :key="i">
                  <a @click="toNav(nav)">{{nav.name}}</a>
                </li>
              </ul>
            </div>
          </template>
        </div>
        <div class="r">
          <div class="bgw">
            <div class="top-head">{{$t(topHead)}}</div>
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Center",
  components: {},
  props: {},
  data() {
    return {
      options: [
        {
          title: this.$t('myCenter'),
          show: true,
          list: [
            {
              name: 'My Account', // 我的信息
              route: "/center/user"
            },
            {
              name: 'My Collection', // 我的收藏
              route: "/center/favourite"
            },
            {
              name: 'My Clubs', // 我的箭馆
              route: "/center/arrows"
            },
            {
              name: this.$t('myfootprint'), // 我的足迹
              route: "/center/footmark"
            },
          ]
        },

        {
          title: 'My Property', // 我的资产
          show: true,
          list: [
            // {
            //   name: this.$t('integral'),
            //   route: "/center/point"
            // },
            // {
            //   name:  this.$t('balance'),
            //   route: "/center/balance"
            // },
            {
              name: 'Withdraw', // 余额提现
              route: "/center/withdrawCash"
            },
            {
              name: 'Add A Paypal',
              route: "/center/ali"
            },
            // {
            //   name: this.$t('yhmana'),
            //   route: "/center/bank"
            // },
            // {
            //   name: 'My Coupons', // 我的优惠券
            //   route: "/center/coupon"
            // },
          ]
        },


        {
          title: 'Video Order', // 我的视频
          show: false,
          list: [
            {
              name: this.$t('videoorder'),
              route: "/center/videoorder"
            }
          ]
        },

        {
          title: this.$t('promotioncenter'), //'推广中心',
          show: false,
          list: [
            {
              name: this.$t("mycommission"), //'我的佣金',
              route: "/center/distribution"
            },
            {
              name: this.$t('promoteUser'), // '我的推广客户',
              route: "/center/distributionClient"
            },
            {
              name: this.$t('commissionGoods'), //'分佣商品',
              route: "/center/goods"
            },
            {
              name: this.$t('promotionposter'), //'分佣商品',
              route: "/center/staffshare"
            },

            {
              name: this.$t('noticetopromoters'), //'推广员须知',
              route: "/help?is_main=2"
            },
            // {
            //   name: this.$t("mycommission"), //'我的佣金',
            //   route: "/center/channel"
            // },
          ]
        },
        {
          title: this.$t('channel'), //'渠道商',
          show: false,
          list: [
            {
              name: this.$t('promotionposter'), //'推广码',
              route: "/center/staffshare"
            },
            {
              name: 'My Commission', //'我的佣金',
              route: "/center/channel"
            },
            {
              name: this.$t('promoteUser') , //'我的推广客户',
              route: "/center/channelclient"
            },
            {
              name: this.$t('channelsofInformation'), //'渠道须知',
              route: "/help?is_main=1"
            },
            {
              name: this.$t('staffList'), //'员工列表',
              route: "/center/staff"
            },
            {
              name: this.$t('staffwithdrawal'), //'员工提现',
              route: "/center/staffwithdrawal"
            },
            {
              name: this.$t('addStaff'), //'添加员工',
              route: "/center/staffadd"
            },
            {
              name: 'Products', //'分佣商品',
              route: "/center/goods"
            },
          ]
        },

        {
          title: 'Affiliate Channel', //'渠道商',
          show: true,
          list: [
            {
              name: 'Affiliate Application', //'渠道商申请',
              route: "/center/channelApply"
            },
          ]
        },


        {
          title: 'Order Center', // 订单中心
          show: true,
          list: [
            {
              name: this.$t('myOrder'), // 我的订单
              route: "/center/myorder"
            },
            {
              name: 'Refund Orders', // 售后订单
              route: "/center/refund"
            }
          ]
        },

        {
          title: this.$t('userInformation'), // 个人信息
          show: true,
          list: [
            {
              name: this.$t('setting'), // 资料设置
              route: "/center/userInfo"
            },
            {
              name: this.$t('securityCenter'),// 安全中心
              route: "/center/safeCenter"
            },
            {
              name: this.$t('shippingAddress'), // 收货地址
              route: "/center/address"
            }
          ]
        }
      ],
      navName: this.$t('myCenter')
    };
  },
  watch: {},
  computed: {
    topHead() {
      for (let i = 0; i < this.options.length; i++) {
        const list = this.options[i].list;
        for (let index = 0; index < list.length; index++) {
          if (list[index].route == this.$route.path) {
            return list[index].name;
          } else {
            return this.$route.meta.ltitle;
          }
        }
      }
    }
  },
  methods: {
    toNav(nav){
      this.navName=nav.name
      this.$router.push(nav.route)
    },
    channeInfo() {
      this.$api.channelbusinessGetInfo().then(res =>{

          console.log('res.status && res.data.status == 2', res)
            // 渠道商通过
            if(res.status && res.data.status == 2) {
              window.localStorage.setItem('businessId', res.data.id)
              // this.options[3].show = false // 关闭分销
              // this.options[4].show = true // 开启渠道

              if( res.data.staff_info.is_main == 1) {
                this.options[3].show = false // 关闭分销
                this.options[4].show = true // 开启渠道
              } else {
                this.options[3].show = true // 关闭分销
                this.options[4].show = false // 开启渠道
              }

              this.options[5].show = false // 关闭渠道申请

            } else {
              // 渠道商没有通过
              // this.options[3].show = true
              // this.options[4].show = false 
            }

            
      })
    }
  },
  created() {
    const _this = this
    this.$api.shopConfig().then(res => {
        if(res.open_distribution == 1) {
          _this.options[3].show = true // 开启分销
        }
        _this.channeInfo()
    })
    
  },
  mounted() {

    
   document.title = this.$t(this.$route.meta.ltitle)
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.wrapper {
  .nav {
    @include line-height(40px);
    font-size: 12px;
    span {
      padding: 0 4px;
      font-size: #757575;
    }
    a:hover {
      color: #000;
    }
  }
  .main {
    display: flex;
    margin-bottom: 20px;
    .l {
      width: 234px;
      margin-right: 20px;
      padding: 40px 0;
      .list-wrap {
        margin-bottom: 20px;
        .title {
          padding-left: 30px;
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          color: #333;
        }
        ul {
          li {
            padding-left: 54px;
            height: 32px;
            line-height: 32px;
            color: #757575;
            a:hover {
              color: $theme-color;
            }
            a.router-link-active {
              color: $theme-color;
            }
            a{
              cursor: pointer;
            }
          }
        }
      }
    }
    .r {
      flex: 1;
      .bgw {
        padding: 24px;
        min-height: 600px;
      }
    }
  }
}
</style>
<style lang="scss">
.top-head {
  font-size: 24px;
  font-weight: 400;
  line-height: 40px;
  color: #757575;
  margin-bottom: 10px;
}
</style>
